import { createAction } from 'redux-act';

export const MOBILEMENU_SET_STATE = createAction('MOBILEMENU_SET_STATE');

export const setMobileMenu = (newState) => dispatch => {
  return dispatch(MOBILEMENU_SET_STATE(newState));
};
